export const APPLICATION_FIELD = "Application";
export const PRIORITY = "Priority";
export const APPROVER = "Approver";
export const BACKGROUND_INFORMATION = "Background Information";
export const BUSINESS_TYPE = "Business Type";
export const BUSINESS_UNIT = "Business Unit";
export const CONFIDENTIALITY = "Confidentiality";
export const CUSTOMER_CLASSIFICATION = "Account Classification";
export const CUSTOMER_PART = "Customer Part";
export const CRM_NO = "CRM Project No.";
export const CSC_LAB = "CSC Laboratory";
export const CURRENCY = "Currency";
export const DEADLINE = "Deadline";
export const DEBITOR_NO = "Account Number";
export const DIRECT_CUSTOMER = "Customer/ Account Name";
export const DIRECT_CUSTOMER_CGR = "CGR";
export const DIRECT_CUSTOMER_LOCATION = "Account Country";
export const DISTRIBUTOR = "Distributor";
export const FINISHING_DATE = "Estimated Finishing Date";
export const INTERNAL_CONTACTS = "Further Internal Contacts";
export const MARKET_SEGMENT = "Market Segment";
export const OEM = "OEM / GVC / IKA";
export const OPPORTUNITY_PRODUCTS = "Opportunity Products";
export const PNS = "PNS Potential";
export const PROCESS_DETAIL = "Application Process Detail";
export const PROCESS_TYPE = "Type of Request";
export const PRODUCTS = "Products";
export const PRODUCT_REFERENCES = "Products";
export const REPORT_LANGUAGE = "Report Language";
export const REPORT_USAGE = "Report Usage";
export const SOLUTION = "Current Solution";
export const SUBSTRATES = "Substrates";
export const TEST_EFFORT_IN_DAYS = "Estimated Test Effort in Days";
export const TEST_LOCATION = "Test Location";
export const TEST_PROGRAM = "Test Program";
export const TEST_PURPOSE = "Test Purpose";
export const EXTERNAL_DEVELOPMENT_BUDGET = "External Development Budget";
export const EXTERNAL_DEVELOPMENT_BUDGET_CURRENCY_CODE = "Currency";
